module.exports = __webpack_public_path__ + "img/bg-cant-find_medium@2x.5ec882e4.webp";